/**
 * 値が範囲に含まれるかテストする
 *
 * @param {*} x 値
 * @param {*} min 最小値
 * @param {*} max 最大値
 * @return {Boolean} 値が範囲に含まれるなら true を返す
 */
export function between (x, min, max) {
  return min <= x && x <= max
}
